import { render, staticRenderFns } from "./ComplianceOverview.vue?vue&type=template&id=fbf0881a&scoped=true&"
import script from "./ComplianceOverview.vue?vue&type=script&lang=js&"
export * from "./ComplianceOverview.vue?vue&type=script&lang=js&"
import style0 from "./ComplianceOverview.vue?vue&type=style&index=0&id=fbf0881a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf0881a",
  null
  
)

export default component.exports